import React from "react";
import Table from "react-bootstrap/Table";

export default function MWDATA(props) {
  const getRec = props.getActionData; 
  return (
    <>
      {getRec ? (
        <>
          <Table stripped bordered hover size="sm">
            <thead>
              <tr className="header-row changefont">
                <th className="indexname" size="3">
                  Symbol
                </th>                 
                <th className="signal" size="3">
                  LTP
                </th>
                <th className="signal" size="3">
                  %CHG
                </th>
                <th className="signal" size="3">
                  Volume
                </th>
                <th className="signal" size="3">
                  52 High
                </th>
                <th className="signal" size="3">
                  52 Low
                </th>
              </tr>
            </thead>
            <tbody>
              {getRec.map((item, key) => (
                <tr key={key}>
                  <td>{item.symbol} </td>
                  <td>{item.ltp} </td>
                  <td>{item.chg} </td>
                  <td>{item.volume} </td>
                  <td>{item['52wh']} </td>
                  <td>{item['52wl']} </td> 
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        ""
      )}
    </>
  );
}
